/**
 * List all possible names
 */
export enum CommunicationWidgetName {
  enforceServiceLimit = 'enforceServiceLimit',
  createAsyncServiceRequest = 'createAsyncServiceRequest',
  offerReservation = 'offerReservation',
}
